import React from 'react';
import Button from '../../../../../components/ComponentsV1/Button';
import { Skeleton } from '../../../../../components/ComponentsV1/Skeleton/Skeleton';
import { PROMPT_MAX_LENGTH, SKELETON_ROWS } from '../constants';
import ConfigDetails from './ConfigDetails';
import { Dropdown, Textarea } from '../../../../../UiKit';
const ConfigSkeleton = () => <Skeleton rows={SKELETON_ROWS} />;

const getTextareaField = (name, title, value, onChange) => (
  <div className='tw-flex tw-flex-col tw-gap-5 tw-flex-1'>
    <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
      {title}
    </div>
    <Textarea
      showBtn={false}
      showMaxLimit={false}
      maxLimit={PROMPT_MAX_LENGTH}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      height='30rem'
    />
  </div>
);

const ConfigResult = ({
  config,
  isActionLoading,
  isUpdateMode,
  setIsUpdateMode,
  showDeleteConfirm,
  setShowDeleteConfirm,
  editModel,
  setEditModel,
  editPrompt,
  setEditPrompt,
  onUpdate,
  onDelete,
}) => {
  if (isActionLoading) return <ConfigSkeleton />;

  if (!config) return null;

  const handleUpdateClick = () => {
    setEditModel(config.model ?? '');
    setEditPrompt(config.prompt ?? '');
    setIsUpdateMode(true);
  };

  const handleCancelUpdate = () => {
    setIsUpdateMode(false);
  };

  return (
    <div className='tw-flex tw-flex-col tw-gap-6'>
      <ConfigDetails config={config} />

      {/* Default action buttons */}
      {!isUpdateMode && !showDeleteConfirm && (
        <div className='tw-flex tw-flex-col tw-gap-3'>
          <div className='tw-text-[1.2rem] tw-text-zinc-500 tw-font-medium'>
            Update will modify the AI model or prompt used for misconduct
            detection.
            <br />
            Delete will remove this configuration from the system.
            <br />
            Choose your action carefully as these changes impact rider
            misconduct analysis.
          </div>
          <div className='tw-flex tw-gap-4'>
            <Button title='Update' onClick={handleUpdateClick} />
            <Button
              title='Delete'
              type='outline'
              onClick={() => setShowDeleteConfirm(true)}
            />
          </div>
        </div>
      )}

      {/* Update form */}
      {isUpdateMode && (
        <div className='tw-flex tw-flex-col tw-gap-6 tw-border tw-border-solid tw-border-[#e5e7eb] tw-rounded-lg tw-p-6'>
          <div className='tw-flex tw-flex-col tw-h-max tw-gap-5 tw-w-1/2'>
            <div className='tw-w-full tw-text-grey-900 tw-font-medium tw-text-500'>
              Model
            </div>
            <div
              css={`
                & div {
                  width: 100%;
                }
              `}
            >
              <Dropdown
                dropDownValues={Object.fromEntries(
                  (config.eligible_models || []).map((m) => [m, m]),
                )}
                onSelect={(value) => setEditModel(value)}
                dropdownVal={editModel}
                placeholder='Select a model'
              />
            </div>
          </div>
          {getTextareaField('prompt', 'Prompt', editPrompt, setEditPrompt)}
          <div className='tw-flex tw-gap-4 tw-justify-end'>
            <Button
              title='Cancel'
              type='outline'
              onClick={handleCancelUpdate}
            />
            <Button
              title='Save Changes'
              onClick={onUpdate}
              disabled={!editPrompt?.trim() || !editModel?.trim()}
            />
          </div>
        </div>
      )}

      {/* Delete confirmation */}
      {showDeleteConfirm && !isUpdateMode && (
        <div className='tw-border tw-border-solid tw-border-red-200 tw-bg-red-50 tw-rounded-lg tw-p-6 tw-flex tw-flex-col tw-gap-8'>
          <div className='tw-text-[1.4rem] tw-font-medium tw-text-zinc-800'>
            Are you sure you want to delete this config?
          </div>
          <div className='tw-flex tw-gap-4'>
            <Button
              title='Cancel'
              type='outline'
              onClick={() => setShowDeleteConfirm(false)}
            />
            <Button title='Confirm Delete' onClick={onDelete} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigResult;
